import RegisterForm1 from "./RegisterForm1";
import RegisterForm2 from "./RegisterForm2";
import RegisterPage1 from "../../../public/assets/register-page1.svg";
import RegisterPage2 from "../../../public/assets/register-page2.svg";
import styles from "../styles/RegisterBody.module.scss";
import React, { useState } from "react";
import { userInfo } from "os";
import { verify } from "crypto";

export default function RegisterBody({
  register,
  handleUserName,
  handlePassword,
  handleConfirmPassword,
  handleFirstName,
  handleLastName,
  handleAge,
  handleEmail,
  handleGender,
  accountCreated,
  email,
  username,
}: {
  register: () => void;
  handleUserName: (event) => void;
  handlePassword: (event) => void;
  handleConfirmPassword: (event) => void;
  handleFirstName: (event) => void;
  handleLastName: (event) => void;
  handleAge: (event) => void;
  handleGender: (event) => void;
  handleEmail: (event) => void;
  accountCreated: boolean;
  email: string;
  username: string;
}) {
  // function handleRegisterEvent() {
  //   window.scroll({ top: 1 });
  //   setAccountCreated(!accountCreated);
  // }

  return (
    <div className={styles.main}>
      <div className={styles.content}>
        <div className={styles.left}>
          {!accountCreated && <RegisterPage1 className={styles.image} />}
          {accountCreated && <RegisterPage2 className={styles.image} />}
        </div>
        <div className={styles.right}>
          {!accountCreated && (
            <RegisterForm1
              handleEmailInput={handleEmail}
              handleUserName={handleUserName}
              handlePassword={handlePassword}
              handleConfirmPassword={handleConfirmPassword}
              handleFirstName={handleFirstName}
              handleLastName={handleLastName}
              handleAge={handleAge}
              handleGender={handleGender}
              register={register}
              email={email}
            />
          )}
          {accountCreated && (
            <RegisterForm2 email={email} username={username} />
          )}
        </div>
      </div>
    </div>
  );
}
